import PropTypes from 'prop-types';
import { localizedString } from '@languages';
import isArray from 'lodash/isArray';
import classNames from 'classnames';
import { HighlightedAddressItem } from './HighlightedAddressItem';
import classes from './AddressFinder.style.module.scss';

export const AddressList = ({
  loading = false,
  data = [],
  onSelect,
  hasError,
  isManualOptionOn,
  onClickManualOption,
  onFocus
}) => {
  if (loading) {
    return (
      <ul className={classes.addresses}>
        <li className={classes.loading}>{localizedString('loading')}</li>
      </ul>
    );
  }

  return (
    <ul className={classes.addresses} id="address-list" role="listbox">
      {hasError && (
        <li className={classes.error}>
          {localizedString('addressNotFound')}
          {isManualOptionOn && (
            <>
              <br />
              {localizedString('orUpperCase')} "{localizedString('enterManually')}"
            </>
          )}
        </li>
      )}
      {!hasError &&
        isArray(data) &&
        data.map(({ text, globalAddressKey = null, expand = false, highlight = null }, index) => {
          return (
            <li
              onClick={() => onSelect({ address: text, globalAddressKey, expand })}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  onSelect({ address: text, globalAddressKey, expand });
                }
              }}
              key={text}
              role="option"
              id={`address-list-${index}`}
              onFocus={onFocus}
              tabIndex={0}
              aria-selected={false}
            >
              <span>
                <img
                  width="18"
                  alt=""
                  src="images/icons/png/map-pointer-videoid.png"
                  aria-hidden="true"
                />
              </span>
              <span className={classes.grow}>
                {highlight ? <HighlightedAddressItem address={text} highlight={highlight} /> : text}
              </span>
              {expand && (
                <span>
                  <img
                    width="18"
                    alt=""
                    src="images/icons/png/forward-videoid.png"
                    aria-hidden="true"
                  />
                </span>
              )}
            </li>
          );
        })}
      {isManualOptionOn && (
        <li
          className="text-right"
          onClick={() => onClickManualOption()}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onClickManualOption();
            }
          }}
          role="option"
          id="address-list-manual"
          onFocus={onFocus}
          tabIndex={0}
          aria-selected={false}
        >
          <span className={classNames('font-weight-bold', classes.grow)}>
            {localizedString('enterManually')}
          </span>
          <span>
            <img width="18" alt="" src="images/icons/png/forward-videoid.png" aria-hidden="true" />
          </span>
        </li>
      )}
    </ul>
  );
};

AddressList.propTypes = {
  loading: PropTypes.bool,
  hasError: PropTypes.bool,
  isManualOptionOn: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      globalAddressKey: PropTypes.string
    })
  ),
  onSelect: PropTypes.func,
  onClickManualOption: PropTypes.func,
  onFocus: PropTypes.func
};
